// extracted by mini-css-extract-plugin
export default {"even":"log_even__KRL8s"};